// Vendor.js

import React, { Component } from 'react';

import './vendor/css/bootstrap.min.css';
import './vendor/css/bootstrap-theme.min.css';

class Vendor extends Component {
    
  render() {
    return (
      <div>
      </div>
    );
  }
}

export default Vendor;
